interface GalleryItem {
  name: string;
  reserveUrl: string;
  imageUrl: string;
}

const galleryItems: GalleryItem[] = [
  {
    name: 'アスタ住宅展示場',
    reserveUrl: 'https://www.giazo.life/hiroshima/?id=1#p-model-reserve',
    imageUrl:
      'https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/71f22208-8ff1-461c-9fd5-ef2ab23adce9_compressed_model_focus_01_a2x.webp',
  },
  {
    name: '東広島ハウジングフェア展示場',
    reserveUrl: 'https://www.giazo.life/higashi-hiroshima/?id=2#p-model-reserve',
    imageUrl:
      'https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/ff818ae6-3b90-42a7-b2a8-eb062c881013_compressed_unnamed.webp',
  },
  {
    name: '住宅宣言ふくやま広島テレビ展示場',
    reserveUrl: 'https://www.giazo.life/fukuyama/?id=3#p-model-reserve',
    imageUrl:
      'https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/824a01d7-f20d-4f48-99f4-c6872da37048_compressed_unnamed.webp',
  },
  {
    name: 'ふれあいホームタウンおのみち',
    reserveUrl: 'https://www.giazo.life/onomichi/?id=4#p-model-reserve',
    imageUrl:
      'https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/30654d96-ac74-4ec4-8bc9-7a0513acebc1_compressed_unnamed.webp',
  },
];

export default function ReservationGallery() {
  return (
    <section id="reservation" className="relative w-full bg-background-50 py-28 md:py-36">
      <div className="w-full px-6 md:px-16">
        <div className="text-center mb-14 md:mb-18">
          <p className="font-sans text-[12px] tracking-[0.2em] text-foreground-400 mb-4">
            RESERVATION / ご来場予約
          </p>
          <h2
            className="font-heading text-[24px] md:text-[32px] tracking-[0.1em] text-foreground-950 mb-4"
            style={{ fontWeight: 300 }}
          >
            モデルハウスへのご来場を、お待ちしております
          </h2>
          <p
            className="font-sans text-[15px] tracking-[0.05em] text-foreground-500"
            style={{ fontWeight: 300 }}
          >
            お気軽に、最寄りの展示場をご予約ください。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {galleryItems.map((item) => (
            <a
              key={item.name}
              href={item.reserveUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col cursor-pointer"
            >
              <div
                className="relative w-full overflow-hidden"
                style={{ aspectRatio: '4/3' }}
              >
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="inline-flex items-center gap-2 bg-background-50 px-5 py-3 text-[13px] tracking-[0.06em] text-foreground-950">
                    見学予約はこちらから
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </div>
              </div>
              <h3
                className="mt-4 font-sans text-[14px] md:text-[15px] tracking-[0.06em] text-foreground-950 group-hover:text-foreground-600 transition-colors duration-300"
                style={{ fontWeight: 400 }}
              >
                {item.name}
              </h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}